import { render, staticRenderFns } from "./ModalErrosIdp.vue?vue&type=template&id=6c4974a5&scoped=true"
import script from "./ModalErrosIdp.vue?vue&type=script&lang=js"
export * from "./ModalErrosIdp.vue?vue&type=script&lang=js"
import style0 from "./ModalErrosIdp.vue?vue&type=style&index=0&id=6c4974a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4974a5",
  null
  
)

export default component.exports